export const html = (strings, ...values) => {
	const tpl = document.createElement('template');
	tpl.innerHTML = String.raw({ raw: strings }, ...values);
	return tpl.content.cloneNode(true);
};

export function reflectBool(el, name, value) {
	if (value) el.setAttribute(name, '');
	else el.removeAttribute(name);
}

export function getBoolAttr(el, name) {
	return el.hasAttribute(name);
}

export function toKebab(str) {
	return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
